
















import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

import { imageUrl } from '@/apiClient'

import { Item, ItemGroup } from '@/models'

@Component
export default class ItemImage extends Vue {
  @Prop({ type: Object, required: true })
  readonly item!: Item | ItemGroup

  @Prop({ type: [Number, String] })
  readonly width?: number | string

  didErrorImage = false

  created () {
    if (this.srcUrl === null) {
      this.$emit('loaded', false)
    }
  }

  get srcUrl (): string | null {
    return imageUrl(this.item)
  }

  get itemImageColor () {
    const name = this.isItem(this.item)
      ? this.item.name
      : this.item.title

    const sum = [...name]
      .map((c) => c.charCodeAt(0))
      .reduce((acc, cur) => acc + cur)

    const index = (this.item.id + sum) % 8

    return 'item-image-c' + index
  }

  @Emit()
  loaded (success: boolean) {
    this.didErrorImage = !success
  }

  isItem (item: Item | ItemGroup): item is Item {
    return (item as Item).name !== undefined
  }
}
